/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint no-use-before-define: ["error", { "functions": false }] */

import { MESSAGES } from '@translations/labels';
import { isEmpty } from '@utils/validation/isEmpty';
import { ANALYTICS_CASE } from '@constants';

const labels = { ...MESSAGES.dashboard };

const kpiOptions = {
  totalUsers: {
    icon: 'users',
    link: false,
    tooltip:
      'Number of users that visited the chatbot within the selected time period. This data gives an insight on the chatbot popularity.',
    name: labels.kpiTotalUsers,
  },
  newUsers: {
    icon: 'users',
    link: false,
    tooltip:
      'Number of new users that came to the chatbot for the first time within the selected period. This data gives an insight on the growth of the chatbot user base.',
    name: labels.kpiNewUsers,
  },
  returningUsers: {
    icon: 'users',
    link: false,
    tooltip:
      'Number of users that visited the chatbot more than once within the selected time period.. This data gives an insight on the chatbot value and its acceptance by the user.',
    name: labels.kpiReturningUsers,
  },
  messagesByConversation: {
    icon: 'conversation',
    link: false,
    tooltip:
      'Average number of messages per conversation within the selected time period. This data gives an insight on the user engagement.',
    name: labels.kpiMessagesByConversation,
    formatFloat: true,
  },
  unusedIntents: {
    icon: 'conversation',
    link: `/conversation-history/by-intent?analyticCase=${ANALYTICS_CASE.UNUSED_INTENTS}`,
    tooltip: '',
    id: ANALYTICS_CASE.UNUSED_INTENTS,
    name: labels.kpiUnusedIntents,
    extraName: labels.currentRelease,
    zeroValue: '-',
  },
  missedMessages: {
    icon: 'conversation',
    link: `/conversation-history/by-message?analyticCase=${ANALYTICS_CASE.MISSED_MESSAGES}`,
    tooltip: 'Number of messages that the chatbot could not answer within the selected time period.',
    id: ANALYTICS_CASE.MISSED_MESSAGES,
    name: labels.kpiMissedMessages,
  },
  userComplaints: {
    icon: 'conversation',
    link: `/conversation-history/by-message?analyticCase=${ANALYTICS_CASE.USER_COMPLAINTS}`,
    tooltip:
      'Number of times users have expressed criticism to the chatbot (swear words, negative expressions, etc…) within the selected time period.',
    id: ANALYTICS_CASE.USER_COMPLAINTS,
    name: labels.kpiUserComplaints,
  },
  lowAccuracy: {
    icon: 'conversation',
    link: false,
    tooltip: '',
    name: labels.kpiLowAccuracy,
  },
  overallAccuracy: {
    icon: 'conversation',
    link: false,
    tooltip: '',
    name: labels.kpiOverallAccuracy,
  },
  unknown: {
    icon: '',
    link: false,
    tooltip: '',
    name: 'unknown',
  },
};

function getKpis(kpis) {
  if (isEmpty(kpis)) return [];
  return Object.keys(kpis).map(kpiKey => {
    const options = kpiOptions[kpiKey] || kpiOptions.unknown;
    return {
      total: kpis[kpiKey].counter,
      desv: 10,
      type: kpiKey,
      ...options,
    };
  });
}

export { getKpis };
